import { Capacitor } from '@capacitor/core';
import { getIdToken } from '../firebase/firestore-rest';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
const NATIVE_API_BASE_URL = 'https://us-central1-finflowtechs.cloudfunctions.net/api';
const LOCAL_EMULATOR_API_BASE_URL = 'http://127.0.0.1:5001/finflowtechs/us-central1/api';
const USE_EMULATORS = process.env.REACT_APP_USE_EMULATORS === 'true';

const normalisePath = (path: string): string => {
  if (!path.startsWith('/')) {
    return `/${path}`;
  }
  return path;
};

export const buildApiUrl = (path: string): string => {
  const normalised = normalisePath(path);
  const isLocalHost =
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const base = API_BASE_URL || (USE_EMULATORS && !Capacitor.isNativePlatform() ? LOCAL_EMULATOR_API_BASE_URL : Capacitor.isNativePlatform() || isLocalHost ? NATIVE_API_BASE_URL : '');
  return `${base}${normalised}`;
};

export const apiFetch = async (path: string, options?: RequestInit) => {
  const headers = new Headers(options?.headers);
  if (!headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${await getIdToken()}`);
  }
  return fetch(buildApiUrl(path), { ...options, headers });
};
